const { REACT_APP_PLATFORM_API, REACT_APP_PRODUCT_RESEARCH_API } = process.env;

export const POST = 'post';
export const PUT = 'put';
export const DELETE = 'delete';
export const GET = 'get';
export const PATCH = 'patch';

export const PLATFORM_API_URLS = {
  users: {
    checkEmail: `https://v2-api-staging.autods.com/users/check-email/`,
    usersList: `https://v2-api-staging.autods.com/users/list/`,
    user: `https://v2-api-staging.autods.com/users/{userId}/`,
    emailConfirmation: `https://v2-api-staging.autods.com/users/email-confirmation/`,
    activateChat: `https://v2-api-staging.autods.com/users/chat/{id}/activate`,
    // Backend mints a short-lived CometChat auth token for the authenticated user
    // (creating the CometChat user if needed). The full-access AUTH_KEY stays server-side.
    // TODO(backend): confirm final path & response shape ({ auth_token: string }).
    cometChatAuthToken: `https://v2-api-staging.autods.com/users/chat/auth-token`,
  },
  utility: {
    getPresignedImageUrl: `https://v2-api-staging.autods.com/utility/get_presigned_image_url`,
  },
};

export const PRODUCT_RESEARCH_API_URLS = {
  catalog: {
    getCatalog: `https://product-finder-api-staging.autods.com/api/catalog/`,
  },
  categories: {
    getCategories: `https://product-finder-api-staging.autods.com/api/categories/`,
  },
  products: {
    getTags: `https://product-finder-api-staging.autods.com/api/products/my/tags`,
    getShopifyCollections: `https://product-finder-api-staging.autods.com/api/products/my/shopify-collections`,
    getProducts: `https://product-finder-api-staging.autods.com/api/products/my/`,
    updateProduct: `https://product-finder-api-staging.autods.com/api/products/my/{id}`,
    bulkAddTags: `https://product-finder-api-staging.autods.com/api/products/my/add-tags`,
    bulkRemoveTags: `https://product-finder-api-staging.autods.com/api/products/my/remove-tags`,
    bulkUpdateProduct: `https://product-finder-api-staging.autods.com/api/products/my/group-update`,
    uploadCsv: `https://product-finder-api-staging.autods.com/api/products/my/import/csv`,
    previewProduct: `https://product-finder-api-staging.autods.com/api/products/my/preview`,
  },
  user: {
    user: `https://product-finder-api-staging.autods.com/api/user/`,
    initUser: `https://product-finder-api-staging.autods.com/api/user/init`,
    submitReview: `https://product-finder-api-staging.autods.com/api/user_settings/submit-for-review`,
    deleteUser: `https://product-finder-api-staging.autods.com/api/user/delete`,
  },
  policy: {
    policy: `https://product-finder-api-staging.autods.com/api/policy/`,
  },
  paymentDetails: {
    paymentDetails: `https://product-finder-api-staging.autods.com/api/payment_details/`,
  },
  orders: {
    orders: `https://product-finder-api-staging.autods.com/api/orders/`,
    downloadOrdersReport: `https://product-finder-api-staging.autods.com/api/orders/send-report/`,
  },
  userSettings: {
    userSettings: `https://product-finder-api-staging.autods.com/api/user_settings/`,
  },
  savedFilters: {
    filters: `https://product-finder-api-staging.autods.com/api/saved-filters/`,
    filter: `https://product-finder-api-staging.autods.com/api/saved-filters/{id}`,
  },
  store: {
    store: `https://product-finder-api-staging.autods.com/api/store/my`,
    synchronizeProducts: `https://product-finder-api-staging.autods.com/api/store/synchronize-products`,
  },
  transactions: {
    transactions: `https://product-finder-api-staging.autods.com/api/transactions/`,
  },
};
